import { Star, Clock, MapPin, Sparkles } from "lucide-react";
import { Reveal } from "@/lib/reveal";
import { CLINIC } from "@/lib/site";
import { useLanguage } from "@/context/LanguageContext";

export const TrustSection = () => {
  const { t } = useLanguage();

  const items = [
    { icon: Sparkles, big: t.trust.freeTitle, label: t.trust.freeLabel, sub: t.trust.freeSub },
    { icon: Star, big: `${CLINIC.rating}★`, label: `${CLINIC.reviews} ${t.hero.reviews}`, sub: t.trust.ratingLabel },
    { icon: Clock, big: CLINIC.hours, label: t.trust.hoursLabel, sub: t.trust.hoursSub },
    { icon: MapPin, big: "Lushnjë", label: t.trust.locationLabel, sub: t.trust.locationSub },
  ];

  return (
    <section data-testid="trust-section" className="border-y border-border bg-card">
      <div className="container-x grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-border">
        {items.map((it, i) => (
          <Reveal key={it.label} delay={i * 0.08} className="py-10 md:py-14 px-6 lg:px-10 first:pl-0 last:pr-0">
            <it.icon size={22} className="text-accent mb-4" />
            <div className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground">{it.big}</div>
            <div className="mt-2.5 text-base font-bold text-foreground">{it.label}</div>
            <div className="text-xs sm:text-sm font-semibold text-muted-foreground mt-0.5">{it.sub}</div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
